// Dataset.kind (backend unio/models/dataset.py DATASET_KINDS): primary data is measured or
// collected; a derived dataset was produced from other datasets by an analysis.
export const DATASET_KINDS = [
  { value: "primary", label: "Primary — measured or collected" },
  { value: "derived", label: "Derived — produced from other datasets" },
];

export const KIND_HINT = "Primary: measured or collected data. Derived: produced from other datasets by an analysis.";
